export class ModuloValutazioneRisposta {
    testo?: string;
    valore?: number;
    descrizione?: string;
}